<template>
  <section id="features" class="home3-features">
    <v-container>
      <div class="home3-section-header text-center mb-10">
        <span class="home3-section-header__tag">Features</span>
        <h2 class="home3-section-header__title">Everything you need to manage school transport</h2>
        <p class="home3-section-header__desc">
          From live GPS tracking to parent notifications — built for schools, drivers, and families.
        </p>
      </div>

      <v-row>
        <v-col
          v-for="(feature, i) in features"
          :key="i"
          cols="12"
          sm="6"
          md="4"
        >
          <v-hover v-slot:default="{ hover }">
            <div class="home3-feature-card" :class="{ 'home3-feature-card--hover': hover }">
              <div class="home3-feature-card__icon-wrap" :style="{ background: feature.bg }">
                <v-img :src="feature.img" max-width="48" contain />
              </div>
              <h3 class="home3-feature-card__title">{{ feature.title }}</h3>
              <p class="home3-feature-card__text">{{ feature.text }}</p>
              <div class="home3-feature-card__accent" :style="{ background: feature.accent }" />
            </div>
          </v-hover>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  data() {
    return {
      features: [
        {
          img: require('@/assets/images/landing/icon1.svg'),
          title: 'Live GPS Tracking',
          text: 'Monitor every bus in real time on an interactive map. Know exactly where students are at every moment.',
          bg: 'rgba(31, 65, 104, 0.08)',
          accent: '#1f4168',
        },
        {
          img: require('@/assets/images/landing/icon2.svg'),
          title: 'Parent Notifications',
          text: 'Automatic alerts when buses approach stops, depart, or experience delays — keeping families informed.',
          bg: 'rgba(215, 137, 59, 0.1)',
          accent: '#d7893b',
        },
        {
          img: require('@/assets/images/landing/icon3.svg'),
          title: 'Trip Management',
          text: 'Plan routes, assign drivers, manage reservations, and oversee the full trip lifecycle from one dashboard.',
          bg: 'rgba(134, 184, 9, 0.1)',
          accent: '#86b809',
        },
        {
          img: require('@/assets/images/landing/paperplane.svg'),
          title: 'Route Optimization',
          text: 'Define stops, set schedules, and optimize routes to reduce travel time and fuel costs.',
          bg: 'rgba(145, 85, 253, 0.08)',
          accent: '#9155FD',
        },
        {
          img: require('@/assets/images/landing/airplane.svg'),
          title: 'Multi-School Support',
          text: 'Scale across multiple schools and fleets with role-based access for admins, schools, and drivers.',
          bg: 'rgba(31, 65, 104, 0.08)',
          accent: '#2d5a8a',
        },
        {
          img: require('@/assets/images/landing/aeroplane.svg'),
          title: 'Secure & Compliant',
          text: 'Enterprise-grade security with encrypted data, audit trails, and privacy controls for student information.',
          bg: 'rgba(215, 137, 59, 0.1)',
          accent: '#B13F1A',
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
@import './home3-theme.scss';

.home3-features {
  @include home3-section-padding;
  background: $home3-surface;
}

.home3-section-header {
  max-width: 640px;
  margin-left: auto;
  margin-right: auto;

  &__tag {
    display: inline-block;
    padding: 4px 14px;
    margin-bottom: 1rem;
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: $home3-primary;
    background: rgba($home3-primary, 0.1);
    border-radius: 100px;
  }

  &__title {
    font-size: clamp(1.75rem, 3vw, 2.25rem);
    font-weight: 700;
    color: $home3-text;
    letter-spacing: -0.02em;
    line-height: 1.2;
    margin-bottom: 1rem;
  }

  &__desc {
    font-size: 1.05rem;
    line-height: 1.7;
    color: $home3-text-muted;
    margin: 0;
  }
}

.home3-feature-card {
  @include home3-card;
  position: relative;
  padding: 2rem 1.75rem;
  height: 100%;
  overflow: hidden;

  &--hover {
    .home3-feature-card__icon-wrap {
      transform: scale(1.08);
    }
  }

  &__icon-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 64px;
    border-radius: 14px;
    margin-bottom: 1.25rem;
    transition: transform 0.3s ease;
  }

  &__title {
    font-size: 1.125rem;
    font-weight: 600;
    color: $home3-text;
    margin-bottom: 0.75rem;
  }

  &__text {
    font-size: 0.925rem;
    line-height: 1.65;
    color: $home3-text-muted;
    margin: 0;
  }

  &__accent {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 3px;
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &--hover &__accent {
    opacity: 1;
  }
}
</style>
